import { useNavigate } from 'react-router-dom';
import SiteHeaderView from './SiteHeaderView';
import { useUser } from '../../context/UserContext';

// In-app instance of the shared navbar (see SiteHeaderView). Rendered inside the
// app Router and always behind AuthGate, so the account action reads "Account"
// and routes locally, Cart routes to /cart and carries the item-count dot,
// Subscribe routes to the in-app /subscribe buy step, and the Free Download
// button is dropped.
export function SiteHeader() {
    const navigate = useNavigate();
    const { userData } = useUser();

    const hasCartItems = (userData?.cartItems?.length ?? 0) > 0;

    return (
        <SiteHeaderView
            cart={{ onClick: () => navigate('/cart') }}
            cartHasItems={hasCartItems}
            account={{ onClick: () => navigate('/account') }}
            accountLabel="Account"
            subscribe={{ onClick: () => navigate('/subscribe') }}
        />
    );
}

export default SiteHeader;
